// Every report in the ERP, grouped by the module it reports on.
//
// Single source for both the sidebar (navigation.js builds the Reports menu
// from it, one divider per group) and the Reports home page (/reports), so a
// new report is added here once and shows up in both places.
//
// Group shape: { key, name, icon (lucide), color, reports: [...] }.
// Report shape: { key, name, href, description, isNew? } — `name` is the short
// sidebar label; `description` is the one-liner on the Reports home card.
// Every report has a matching report permission for UI + API access.
//
// Rebuilt from scratch since 2026-10-28.
import { Database, Calculator, Flame } from "lucide-react";

export const REPORT_GROUPS = [
  {
    key: "masters",
    name: "Masters",
    icon: Database,
    color: "#0f766e",
    reports: [
      {
        key: "master",
        permission: "view_report_master",
        name: "Master Report",
        href: "/reports/master",
        description: "Search a customer: orders, avg weight and ₹/kg, monthly sales vs every customer, delivery, payments and rejection.",
        isNew: true,
      },
    ],
  },
  {
    key: "production",
    name: "Production",
    icon: Flame,
    color: "#c2410c",
    reports: [
      {
        key: "heats",
        permission: "view_report_heats",
        name: "Heat Report",
        href: "/reports/heats",
        description: "A month of melting: MSEDCL meter start → end units, furnace kWh per tonne, normal and doubling heats per furnace with avg weight.",
        isNew: true,
      },
    ],
  },
  {
    key: "management",
    name: "Management",
    icon: Calculator,
    color: "#b45309",
    reports: [
      {
        key: "costing",
        permission: "view_report_costing",
        name: "Costing",
        href: "/reports/costing",
        description: "Cost per kg of good casting for a month — scrap, alloys, sand, power, labour, HT, fettling — vs sale ₹/kg: margin and profit / loss.",
        isNew: true,
      },
    ],
  },
];

// "/reports" with no tab (or ?view=all) is the Reports home page.
export const REPORTS_HOME_HREF = "/reports?view=all";
